import { useDispatch, useSelector } from 'react-redux';
import { setIsError } from '../../store/error/error.action';
import {
    selectErrorMessage,
    selectIsError,
} from '../../store/error/error.selector';
import ErrorSnackbar from '../ui/error-snackbar/error-snackbar.component';
import ContentWrapper from './content-wrapper/content-wrapper.component';
import { FlexBoxFullWHColumn } from './layout.styles';
import TopBar from './top-bar/top-bar.component';

export default function Layout() {
    const dispatch = useDispatch();

    const error = useSelector(selectIsError);
    const errorMessage = useSelector(selectErrorMessage);

    const handleCloseSnackbar = () => {
        dispatch(setIsError(false, null));
    };

    return (
        <FlexBoxFullWHColumn overflow={'hidden'}>
            {error && (
                <ErrorSnackbar
                    open={true}
                    msg={errorMessage}
                    onClose={handleCloseSnackbar}
                />
            )}
            <TopBar />
            <ContentWrapper />
        </FlexBoxFullWHColumn>
    );
}
